import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";
import http from "@/lib/api";
import { useNoIndex } from "@/lib/useNoIndex";

export default function AdminLogin() {
  useNoIndex();
  const navigate = useNavigate();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const res = await http.post("/v1/admin/login", { username, password });
      if (res.data.token) {
        localStorage.setItem("admin_token", res.data.token);
        localStorage.setItem("admin_name", res.data.display_name || username);
        localStorage.setItem("admin_role", res.data.role || "admin");
        toast.success("Innlogget!");
        navigate(res.data.role === "workshop" ? "/admin/skann" : "/admin/dashboard");
      } else {
        toast.error("Innlogging feilet. Sjekk brukernavn og passord.");
      }
    } catch {
      toast.error("Innlogging feilet. Sjekk brukernavn og passord.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-900 p-4">
      <Card className="w-full max-w-md bg-slate-800 border-slate-700">
        <CardHeader className="text-center">
          <CardTitle className="text-2xl text-white">Bergen Serviceverksted</CardTitle>
          <CardDescription className="text-slate-400">Adminpanel – Logg inn</CardDescription>
        </CardHeader>
        <CardContent>
          <form onSubmit={handleLogin} className="space-y-4">
            <div className="space-y-2">
              <Label htmlFor="username" className="text-slate-200">Brukernavn</Label>
              <Input id="username" type="text" value={username} onChange={(e) => setUsername(e.target.value)} placeholder="Brukernavn" className="bg-slate-700 border-slate-600 text-white placeholder:text-slate-400" data-testid="admin-username" required />
            </div>
            <div className="space-y-2">
              <Label htmlFor="password" className="text-slate-200">Passord</Label>
              <Input id="password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} placeholder="Passord" className="bg-slate-700 border-slate-600 text-white placeholder:text-slate-400" data-testid="admin-password" required />
            </div>
            <Button type="submit" className="w-full bg-blue-600 hover:bg-blue-700 text-white" disabled={loading} data-testid="admin-login-btn">{loading ? "Logger inn..." : "Logg inn"}</Button>
          </form>
        </CardContent>
      </Card>
    </div>
  );
}
